import { EntityType } from '@boma/shared/entities';
import { LocationType } from '../enums/location-type';

export interface IProfile {
  id: string;
  firstName: string;
  surname: string;
  entities: IProfileEntity[];
  createdAt: Date;
  updatedAt: Date;
}

export interface IProfileEntity {
  id: string;
  name: string;
  permissions: string[];
  type: EntityType;
}

export interface IProfileLocation {
  id: string;
  name: string;
  permissions: string[];
  country: IProfileLocationCountry;
  point: IProfileLocationCountryPoint;
  type: LocationType;
  notificationEmailAddress: string;
  contactPersonName: string;
  contactPersonNumber: string;
}

export interface IProfileLocationCountry {
  id: string;
  name: string;
  isoCurrencySymbol: string;
  currencyName: string;
  currencySymbol: string;
  isMetric: boolean;
}

export interface IProfileLocationCountryPoint {
  type: string;
  coordinates: number[];
}
